import React, { useState } from 'react'
import _ from 'underscore'

import Spinner from 'components/Spinner'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import Plot from 'pages/Device/ThermostatRthPanel/Chart/Plot'
import Cycles from 'pages/Device/ThermostatRthPanel/Cycles'
import FAQ from 'pages/Device/ThermostatRthPanel/FAQ'

import { RuntimeHistory } from 'types/RuntimeHistory'

import styled from 'styled-components'

import Api from 'services/api'

import GA4 from 'helpers/ga4'
import { color } from 'styles/colors'

import blobToFileDownload from 'helpers/blobToFileDownload'

interface ZoneSeries {
  name: string
  series: Array<string> | null
}

interface SelectedLegends {
  series: Array<string> | null
  zoneSeries: Array<ZoneSeries> | null
  alerts: Array<string> | null
}

type Props = {
  startTime: string,
  endTime: string,
  timeZone: string,
  deviceId: string,
  zoomedCallback: (isZoomed: boolean) => void
  freezeMouseHoverCallback: (freeze: boolean) => void
  updateSelectedLegendsCallback: (selectedLegendItem: SelectedLegends) => void
  freezeMouseHover: boolean,
  showFullScreen: boolean,
  isZoomed: boolean,
  rthData: RuntimeHistory | null
  isRTHDataLoaded?: boolean,
  dealerId: number,
  deviceType: string,
  isNoData: boolean
}

const Chart = ({
  startTime,
  endTime,
  timeZone,
  deviceId,
  rthData,
  isRTHDataLoaded = false,
  isZoomed,
  zoomedCallback,
  showFullScreen,
  freezeMouseHover,
  updateSelectedLegendsCallback,
  freezeMouseHoverCallback,
  dealerId,
  deviceType,
  isNoData
}: Props) => {
  const [isFaqModalOpen, setIsFaqModalOpen] = useState(false)

  if (!isRTHDataLoaded) {
    return <Spinner variant="page" />
  }

  const onClickDownloadLink = () => {
    Api.RuntimeHistory.getCSV(dealerId ? dealerId.toString() : '', deviceId, startTime, endTime, deviceType, timeZone).then((response) => {
      const blob = new Blob([response.data], { type: 'text/csv' })
      blobToFileDownload(blob, `runtime_history_${deviceId}_${startTime}_${endTime}.csv`)

      GA4.sendEvent({ category: 'Customer Detail Page', action: 'Download Runtime History CSV' })
    })
  }

  return (
    <>
      <Plot
        deviceId={deviceId}
        isControlHub={rthData ? rthData.isControlHub : false}
        rthData={rthData}
        startTime={startTime}
        endTime={endTime}
        timeZone={timeZone}
        isZoomed={isZoomed}
        zoomedCallback={zoomedCallback}
        freezeMouseHover={freezeMouseHover}
        freezeMouseHoverCallback={freezeMouseHoverCallback}
        showFullScreen={showFullScreen}
        updateSelectedLegendsCallback={updateSelectedLegendsCallback}
        chartDivId="plotly-rth-chart"
      />
      {rthData && (!_.isEmpty(rthData?.stages) || _.compact(_.values(rthData?.accessoriesOperationOccurrence)).length > 0) && <Cycles stages={rthData.stages} accessories={rthData.accessoriesOperationOccurrence} />}

      <S.BottomRow $nodata={isNoData}>
        {!isNoData &&
          <S.DownloadLink
            onClick={onClickDownloadLink}
          >
            Download Runtime History CSV
          </S.DownloadLink>
        }

        <>
          <Button decoration="tertiary" styles={{ button: { marginLeft: 5 } }} onPress={() => setIsFaqModalOpen(true)}><S.Text>FAQS</S.Text></Button>
          <FAQ isDisplayed={isFaqModalOpen} closeCallback={() => setIsFaqModalOpen(false)} />
        </>
      </S.BottomRow>
    </>
  )
}

export default Chart

const S = {
  DownloadLink: styled.a`
    margin: 5px 15px;
    display: inline-block;
  `,
  BottomRow: styled.div<{ $nodata: boolean }>`
    display: flex;
    justify-content: ${({ $nodata }) => $nodata ? 'flex-end' : 'space-between'};
  `,
  Text: styled.div`
    color: ${color('primaryButton')};
    font-weight: 700;
    font-size: 13px;

    &:hover {
      color: ${color('primaryButtonHover')};
    }
  `
}
